import { createFileRoute } from "@tanstack/react-router";
import { AgentWorkflowPage } from "@/components/agent-cli-pages";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/agent/publish-approved-posts";
export const Route = createFileRoute(path)({
	component: () => <AgentWorkflowPage slug="publish-approved-posts" />,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Publish Approved Posts with an AI Agent",
			description:
				"Publish approved social posts and monitor every provider delivery through success, processing, or failure.",
		}),
});
